/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Tabs, Tab, Spinner, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Collapse } from "antd";
import { dateFormatter } from "../../../../../_helpers/dateFormatter";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
const { Panel } = Collapse;

export default (props) => {
  const {
    upcomingEventsLoading,
    pastEventsLoading,
    calendarUpcomingInterviews,
    calendarPastInterviews,
    onScrollPastEvents,
    onScrollUpcomingEvents,
    upcomingEventsRef,
    pastEventsRef,
    onJoinHMSClick,
    onViewProfile,
    onCreateEventClick,
  } = props;
  const { calendarUpcomingScheduledEventListsData } = useSelector(
    (state) => state.get_calendar_upcoming_scheduled_event_lists_data_reducer
  );
  const { calendarPastScheduledEventListsData } = useSelector(
    (state) => state.get_calendar_past_scheduled_event_lists_data_reducer
  );
  return (
    <div className="scheduled-events-wrapper event-list">
      <div className="d-flex align-items-start justify-content-between border-bottom">
        <div className="d-flex align-items-center mb-4">
          <div className="top-filter">
            <h2>Scheduled Events </h2>
          </div>
        </div>
        <button
          className="btn btn-primary border-radius-10 d-flex"
          onClick={onCreateEventClick}
        >
          <FontAwesomeIcon icon={faPlus} className="mr-md-2" />
          <span className="d-none d-md-block">New Event</span>
        </button>
      </div>
      <div className="bg-white border-radius-10 border mt-4">
        <Tabs
          defaultActiveKey="UpcomingScheduledEvents"
          className="event-tabs m-3"
        >
          <Tab eventKey="UpcomingScheduledEvents" title="Upcoming">
            {Array.isArray(calendarUpcomingInterviews) &&
            calendarUpcomingInterviews.length > 0 ? (
              <div onScroll={onScrollUpcomingEvents} ref={upcomingEventsRef}>
                <div className="event-wrapper row mx-md-0">
                  {calendarUpcomingInterviews &&
                    Array.isArray(calendarUpcomingInterviews) &&
                    calendarUpcomingInterviews.map((item) => (
                      <div className="col-md-6 col-xl-4 mb-2">
                        <div className="common-event-list py-2 px-3">
                          <div className="d-flex align-items-start flex-wrap">
                            <div className="d-flex flex-column mr-3 mr-lg-4">
                              <span className="font-weight-medium fs-14">
                                <span>
                                  {item?.interview &&
                                    item.interview?.local_timezone &&
                                    item.interview.local_timezone?.start_time &&
                                    item.interview.local_timezone.start_time.slice(
                                      0,
                                      -3
                                    )}
                                </span>{" "}
                                -{" "}
                                <span>
                                  {item?.interview &&
                                    item.interview?.local_timezone &&
                                    item.interview.local_timezone?.end_time &&
                                    item.interview.local_timezone.end_time.slice(
                                      0,
                                      -3
                                    )}
                                </span>
                                <span>
                                  {" "}
                                  {item?.joinee && item.joinee?.timezone}
                                </span>
                              </span>
                              <p className=" text-grey-4 fs-14">
                                {item?.interview &&
                                  item.interview?.event_details &&
                                  item.interview.event_details?.title}
                              </p>
                            </div>
                            <div className="ml-auto">
                              <button
                                className="btn btn-primary"
                                onClick={() =>
                                  onJoinHMSClick(
                                    item?.interview &&
                                      item.interview?.event_details &&
                                      item.interview.event_details?.id,
                                    item?.interview &&
                                      item.interview?.hms_room_id
                                  )
                                }
                              >
                                Join
                              </button>
                            </div>
                          </div>

                          <div className="more-information d-none d-md-block">
                            <h4 className="font-weight-bold text-uppercase mt-3 mb-2">
                              Event Details
                            </h4>
                            <p className="text-grey-4 mb-0">Name</p>
                            <p className="font-weight-semi mb-2">
                              {item?.interview &&
                              item.interview?.candidate_details ? (
                                <button
                                  onClick={() => onViewProfile(item?.joinee)}
                                  className="bg-transparent border-0 text-left text-primary font-weight-medium px-0 text-capitalize"
                                >
                                  {" "}
                                  {item?.interview &&
                                    item.interview?.candidate_details &&
                                    item.interview.candidate_details?.full_name}
                                </button>
                              ) : (
                                <p className="font-weight-medium">
                                  {" "}
                                  {item?.joinee && item.joinee?.name}
                                </p>
                              )}
                            </p>

                            <p className="text-grey-4 mb-0">Email</p>
                            <p className="font-weight-semi">
                              {item?.joinee && item.joinee?.email}
                            </p>
                            <p className="text-grey-4 mb-0">Meeting Notes</p>
                            <p className="font-weight-semi">
                              {item?.interview &&
                              item.interview?.additional_note
                                ? item?.interview &&
                                  item.interview?.additional_note
                                : "NA"}
                            </p>
                            <p className="text-grey-4 mb-0"> Scheduled on</p>
                            <p className="font-weight-semi">
                              {item?.interview &&
                                item.interview?.created &&
                                dateFormatter(
                                  item?.interview &&
                                    item.interview?.local_timezone &&
                                    item.interview.local_timezone
                                      ?.interview_date
                                )}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                <div className="d-flex col-12 justify-content-center align-items-center"></div>
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center flex-column py-4">
                <img src="/assets/images/empty-state.svg" alt="empty" />
                <h4 className="font-weight-bold mb-1 mt-2">
                  No upcoming scheduled events.
                </h4>
                <p className="mb-4 fs-smallest">
                  Schedule an event to interview candidates
                </p>
                <Link
                  to={"/create-event"}
                  className="px-4 border border-primary shadow
text-primary py-1 rounded-lg font-weight-semi"
                >
                  Create Event
                </Link>
              </div>
            )}
            {upcomingEventsLoading && (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="primary" />
              </div>
            )}
            {!upcomingEventsLoading && (
              <div className="d-flex justify-content-center align-items-center">
                <p className="font-weight-bold mt-4 text-dark">
                  Showing{" "}
                  {calendarUpcomingInterviews &&
                    Array.isArray(calendarUpcomingInterviews) &&
                    calendarUpcomingInterviews.length}{" "}
                  of{" "}
                  {calendarUpcomingScheduledEventListsData?.data &&
                    calendarUpcomingScheduledEventListsData.data?.count}{" "}
                  events
                </p>
              </div>
            )}
          </Tab>
          <Tab eventKey="PastScheduledEvents" title="Past">
            {Array.isArray(calendarPastInterviews) &&
            calendarPastInterviews.length > 0 ? (
              <div
                onScroll={onScrollPastEvents}
                ref={pastEventsRef}
                style={{ overflowY: "auto" }}
                className="row mx-md-0"
              >
                {calendarPastInterviews &&
                  Array.isArray(calendarPastInterviews) &&
                  calendarPastInterviews.map((item, index) => (
                    <div className="col-md-6 col-xl-4 my-2">
                      <div className="event text-capitalize p-md-3 px-3 pt-2">
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <span className="font-weight-medium fs-14">
                              <span>
                                {item?.interview &&
                                  item.interview?.local_timezone &&
                                  item.interview.local_timezone?.start_time &&
                                  item.interview.local_timezone.start_time.slice(
                                    0,
                                    5
                                  )}
                              </span>{" "}
                              -{" "}
                              <span>
                                {item?.interview &&
                                  item.interview?.local_timezone &&
                                  item.interview.local_timezone?.end_time &&
                                  item.interview.local_timezone.end_time.slice(
                                    0,
                                    5
                                  )}
                              </span>
                              <span>
                                {" "}
                                {item?.joinee && item.joinee?.timezone}
                              </span>
                            </span>
                            <p className="event-type">
                              <span className="text-grey-4">
                                {item?.interview &&
                                  item.interview?.event_details &&
                                  item.interview.event_details?.title}
                              </span>
                            </p>
                          </div>
                          <button className="btn btn-primary" disabled>
                            Join
                          </button>
                        </div>
                        <div className="more-information d-none d-md-block">
                          <h4 className="font-weight-bold text-uppercase">
                            Name
                          </h4>
                          {item?.interview &&
                          item.interview?.candidate_details ? (
                            <button
                              onClick={() => onViewProfile(item?.joinee)}
                              className="bg-transparent border-0 text-left text-primary font-weight-medium px-0 mb-2"
                            >
                              {" "}
                              {item?.interview &&
                                item.interview?.candidate_details &&
                                item.interview.candidate_details?.full_name}
                            </button>
                          ) : (
                            <p className="font-weight-medium">
                              {item?.joinee && item.joinee?.full_name}
                            </p>
                          )}
                          <h4 className="font-weight-bold text-uppercase">
                            Email
                          </h4>
                          <p>{item?.joinee && item.joinee?.email}</p>
                          <h4 className="font-weight-bold text-uppercase">
                            INVITEE Time Zone
                          </h4>
                          <p>Indian Standard Time</p>
                          {item?.joinee && item.joinee?.additional_note ? (
                            <>
                              <h4 className="font-weight-bold text-uppercase">
                                Meeting Notes
                              </h4>
                              <p>
                                {item?.joinee && item.joinee?.additional_note}
                              </p>
                            </>
                          ) : null}

                          <p className="mt-4 text-grey-4">
                            <em>
                              Sheduled on{" "}
                              {item?.interview &&
                                item.interview?.local_timezone &&
                                item.interview?.local_timezone &&
                                item.interview.local_timezone?.interview_date &&
                                dateFormatter(
                                  item?.interview &&
                                    item.interview?.local_timezone &&
                                    item.interview?.local_timezone &&
                                    item.interview.local_timezone
                                      ?.interview_date
                                )}
                            </em>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            ) : (
              <div
                className="d-flex align-items-center
justify-content-center flex-column py-4"
              >
                <img src="/assets/images/empty-state.svg" alt="empty" />
                <h4 className="font-weight-bold mb-1 mt-2">
                  No upcoming/past scheduled events found
                </h4>
                <p className="mb-4 fs-smallest">
                  Schedule an event to interview candidates
                </p>
                <Link
                  to={"/create-event"}
                  className="px-4 border border-primary shadow
text-primary py-1 rounded-lg font-weight-semi"
                >
                  Create Event
                </Link>
              </div>
            )}

            {pastEventsLoading && (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="primary" />
              </div>
            )}
            {!pastEventsLoading && (
              <div className="d-flex justify-content-center align-items-center">
                <p className="font-weight-bold mt-4 text-dark">
                  Showing{" "}
                  {Array.isArray(calendarPastInterviews) &&
                    calendarPastInterviews &&
                    calendarPastInterviews.length}{" "}
                  of{" "}
                  {calendarPastScheduledEventListsData?.data &&
                    calendarPastScheduledEventListsData.data?.count}{" "}
                  events
                </p>
              </div>
            )}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};
